export const DEFAULT_CLOUDINARY_METADATA_BASE =
  'q_auto,f_auto,c_limit/dpr_2.0/';
export const DEFAULT_CLOUDINARY_METADATA = `w_720,h_720,${DEFAULT_CLOUDINARY_METADATA_BASE}`;
export const COURSE_IMAGE_CLOUDINARY_METADATA =
  'w_200,h_200,q_auto,f_auto,c_limit/dpr_2.0/';
export const CLOUDINARY_VIDEO_URL_PREFIX =
  'https://edume-res.cloudinary.com/video/upload/';
